"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _actions = require("./actions");

var _fluxActions = require("flux-actions");

var _constants = require("./constants");

var _Property = _interopRequireDefault(require("settings-ui-sdk/Properties/Property"));

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _fromJS, _handleActions;

var initialState = (0, _immutable.fromJS)((_fromJS = {}, (0, _defineProperty2.default)(_fromJS, _constants.COMPANIES, (0, _immutable.Map)()), (0, _defineProperty2.default)(_fromJS, _constants.CONTACTS, (0, _immutable.Map)()), (0, _defineProperty2.default)(_fromJS, _constants.OWNERS, (0, _immutable.fromJS)(_constants.OWNER_PROPERTIES)), (0, _defineProperty2.default)(_fromJS, _constants.PRODUCTS, (0, _immutable.Map)()), _fromJS));

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchCompanyPropertiesActionTypes.SUCCESS, function (state, action) {
  var companyProperties = state.get('companies');
  return state.set(_constants.COMPANIES, companyProperties.withMutations(function (map) {
    action.payload.data.reduce(function (acc, item) {
      return acc.set(item.name, new _Property.default(item));
    }, map);
  }));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchContactPropertiesActionTypes.SUCCESS, function (state, action) {
  var contactProperties = state.get('contacts');
  return state.set(_constants.CONTACTS, contactProperties.withMutations(function (map) {
    action.payload.data.reduce(function (acc, item) {
      return acc.set(item.name, new _Property.default(item));
    }, map);
  }));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchProductPropertiesActionTypes.SUCCESS, function (state, action) {
  var productProperties = state.get(_constants.PRODUCTS);
  return state.set(_constants.PRODUCTS, productProperties.withMutations(function (map) {
    action.payload.data.reduce(function (acc, item) {
      return acc.set(item.name, _PropertyRecord.default.fromJS(item));
    }, map);
  }));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;